import { render, staticRenderFns } from "./Configs.vue?vue&type=template&id=7f6217ce&scoped=true"
import script from "./Configs.vue?vue&type=script&lang=ts"
export * from "./Configs.vue?vue&type=script&lang=ts"
import style0 from "./Configs.vue?vue&type=style&index=0&id=7f6217ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6217ce",
  null
  
)

export default component.exports